const doc = document

const dom = {
  html: doc.documentElement,
  body: doc.body
}

export default dom